import { render, staticRenderFns } from "./RegisterRemedy.vue?vue&type=template&id=08d35796&scoped=true"
import script from "./RegisterRemedy.vue?vue&type=script&lang=js"
export * from "./RegisterRemedy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d35796",
  null
  
)

export default component.exports